import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { siteData } from "../mock";

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section className="container-tight py-24">
      <div className="grid lg:grid-cols-5 gap-12">
        <div className="lg:col-span-2">
          <span className="chip mb-4">Des questions ?</span>
          <h2 className="font-serif text-4xl md:text-5xl font-medium text-[#1a1815] tracking-tight leading-[1.05]">
            Tout ce que vous devez savoir
          </h2>
          <p className="mt-4 text-[#4a4642]">
            Une question qui n'est pas ici ? Contactez-moi directement, je vous réponds rapidement.
          </p>
          <a href={`tel:${siteData.practitioner.phone.replace(/\s/g, "")}`} className="btn-outline mt-6">
            {siteData.practitioner.phone}
          </a>
        </div>

        <div className="lg:col-span-3">
          <div className="space-y-3">
            {siteData.faq.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={f.q}
                  className={`bg-white rounded-2xl border transition-all ${
                    isOpen ? "border-[#d97757]/50" : "border-[#e8e0d5]"
                  }`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between text-left p-6"
                  >
                    <span className="font-serif text-lg font-medium text-[#1a1815] pr-4">{f.q}</span>
                    <span className="w-8 h-8 rounded-full bg-[#f7f2ec] flex items-center justify-center flex-shrink-0">
                      {isOpen ? <Minus size={14} /> : <Plus size={14} />}
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-6 pb-6 text-[#4a4642] leading-relaxed text-[15px] fade-in">
                      {f.a}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
